jQuery(document).ready(function () {
    var isMobile = navigator.userAgent.match(/(iPhone|iPod|iPad|Android|BlackBerry)/);

    //megamenu
    function addMega() {
        var curMenu = $(this);
        curMenu.siblings().removeClass("hovering");
        curMenu.addClass("hovering");
        curMenu.children("div.menu").css("z-index", 1000);
        curMenu.siblings().children("div.menu").css("z-index", 0);
        curMenu.children("div.menu").fadeIn(600);
    }

    function removeMega() {
        var curMenu = $(this);
        curMenu.removeClass("hovering");
        curMenu.children("div.menu").css("z-index", 0);
        curMenu.children("div.menu").fadeOut(400);
    }

    var megaConfig = {
        interval: 100,
        sensitivity: 4,
        over: addMega,
        timeout: 800,
        out: removeMega
    };
    
    if(! isMobile)
        $("li.mega").hoverIntent(megaConfig);
    
    $("li.mega div.navitem a").click(function () {
        if (!isMobile) {
            document.location.href = $(this).data("landinglink");
            return false;
        }
    });

    $("div.menu select").mouseout(function (e) {
        e.stopPropagation();
    });
    
    $(document).on('touchstart', function (event) {
        if ($(event.target).closest('div.close').length) {
            //touch close button
            var curMenuTouchCollapse = $(event.target).closest('li.mega.hovering');
            curMenuTouchCollapse.removeClass("hovering");
            curMenuTouchCollapse.children("div.menu").css("z-index", 0);
            curMenuTouchCollapse.children("div.menu").fadeOut(400);
        } else {
            if (!$(event.target).closest('li.mega').length) {
                //touch outside the megamenus - close megamenu
                var curMenu = $("li.mega");
                curMenu.removeClass("hovering");
                curMenu.children("div.menu").css("z-index", 0);
                curMenu.children("div.menu").fadeOut(400);
            } else {
                if (!$(event.target).closest('div.menu').length) {
                    //touch inside megamenu
                    if ($(event.target).closest('li.mega.hovering').length) {
                        //touch on the expanded menu title - go to landing page
                        document.location.href = $(event.target).data("landinglink");
                    } else {
                        //touch title of different menu... close current menu and open the other
                        var curMenuTouch = $(event.target).closest('li.mega');
                        curMenuTouch.siblings().removeClass("hovering");
                        curMenuTouch.addClass("hovering");
                        curMenuTouch.children("div.menu").css("z-index", 1000);
                        curMenuTouch.siblings().children("div.menu").css("z-index", 0);
                        curMenuTouch.siblings().children("div.menu").fadeOut(400);
                        curMenuTouch.children("div.menu").fadeIn(600);
                    }
                }
            }
        }
    });


    //secondary menu
    $("div.topnav ul li").hover(function () {
        $(this).addClass("hovering");
        $(this).children("div.menu").css("display", "block");
    }, function () {
        $(this).removeClass("hovering");
        $(this).children("div.menu").css("display", "none");
    });

    //Select box
    $('select').change(function () {
        $(this).siblings("div.customStyleSelectBox").children("div.text").text($(this).find(":selected").text());
    });
    $('select').change();

    //Expand/Collapse
    $('#readmoreContainerClose').click(function () {
        $("#readmoreContainerClose").fadeToggle("300", function () {
            $("#readmoreContainer").css("opacity", "1.0").slideToggle("300", function () {
                $(this).animate({
                    "opacity": 0.0
                }, "slow");
                $("#readmore").fadeToggle("300");
            });
        });
    });
    $('#readmore').click(function () {
        $("#readmore").fadeToggle("300", function () {
            $('#readmoreContainer').css("opacity", "0.0").slideToggle("300", function () {
                $(this).animate({
                    "opacity": 1.0
                }, "slow");
                $("#readmoreContainerClose").fadeToggle("300");
            });
        });
    });

    $('#readmoreContainerClose1').click(function () {
        $("#readmoreContainerClose1").fadeToggle("300", function () {
            $("#readmoreContainer1").css("opacity", "1.0").slideToggle("300", function () {
                $(this).animate({
                    "opacity": 0.0
                }, "slow");
                $("#readmore1").fadeToggle("300");
            });
        });
    });
    $('#readmore1').click(function () {
        $("#readmore1").fadeToggle("300", function () {
            $('#readmoreContainer1').css("opacity", "0.0").slideToggle("300", function () {
                $(this).animate({
                    "opacity": 1.0
                }, "slow");
                $("#readmoreContainerClose1").fadeToggle("300");
            });
        });
    });

    $('#readmoreContainerClose2').click(function () {
        $("#readmoreContainerClose2").fadeToggle("300", function () {
            $("#readmoreContainer2").css("opacity", "1.0").slideToggle("300", function () {
                $(this).animate({
                    "opacity": 0.0
                }, "slow");
                $("#readmore2").fadeToggle("300");
            });
        });
    });
    $('#readmore2').click(function () {
        $("#readmore2").fadeToggle("300", function () {
            $('#readmoreContainer2').css("opacity", "0.0").slideToggle("300", function () {
                $(this).animate({
                    "opacity": 1.0
                }, "slow");
                $("#readmoreContainerClose2").fadeToggle("300");
            });
        });
    });

    $('#readmoreContainerClose3').click(function () {
        $("#readmoreContainerClose3").fadeToggle("300", function () {
            $("#readmoreContainer3").css("opacity", "1.0").slideToggle("300", function () {
                $(this).animate({
                    "opacity": 0.0
                }, "slow");
                $("#readmore3").fadeToggle("300");
            });
        });
    });
    $('#readmore3').click(function () {
        $("#readmore3").fadeToggle("300", function () {
            $('#readmoreContainer3').css("opacity", "0.0").slideToggle("300", function () {
                $(this).animate({
                    "opacity": 1.0
                }, "slow");
                $("#readmoreContainerClose3").fadeToggle("300");
            });
        });
    });

    $('#readmoreContainerClose4').click(function () {
        $("#readmoreContainerClose4").fadeToggle("300", function () {
            $("#readmoreContainer4").css("opacity", "1.0").slideToggle("300", function () {
                $(this).animate({
                    "opacity": 0.0
                }, "slow");
                $("#readmore4").fadeToggle("300");
            });
        });
    });
    $('#readmore4').click(function () {
        $("#readmore4").fadeToggle("300", function () {
            $('#readmoreContainer4').css("opacity", "0.0").slideToggle("300", function () {
                $(this).animate({
                    "opacity": 1.0
                }, "slow");
                $("#readmoreContainerClose4").fadeToggle("300");
            });
        });
    });

    $('#readmoreContainerClose5').click(function () {
        $("#readmoreContainerClose5").fadeToggle("300", function () {
            $("#readmoreContainer5").css("opacity", "1.0").slideToggle("300", function () {
                $(this).animate({
                    "opacity": 0.0
                }, "slow");
                $("#readmore5").fadeToggle("300");
            });
        });
    });
    $('#readmore5').click(function () {
        $("#readmore5").fadeToggle("300", function () {
            $('#readmoreContainer5').css("opacity", "0.0").slideToggle("300", function () {
                $(this).animate({
                    "opacity": 1.0
                }, "slow");
                $("#readmoreContainerClose5").fadeToggle("300");
            });
        });
    });
    //attorney tabs
    $("div.attorneytab").hide();
    $("ul.tabsLeft li").click(function (e) {
        
        $("div.attorneytab").hide();
        var activeTab = $(this).find("a").attr("id").replace("#", "#tab");
        $(activeTab).fadeIn();

        $("li.tablink").removeClass("active");
        $(this).addClass("active");
    });
    
    if (location.hash != "" && $(location.hash.replace("#", "#tab")).length > 0) {
        var tabid = location.hash.replace("#", "#tab")
        $("a[href=\"\\" + location.hash + "\"]").parent("ul.tabsLeft li").addClass("active");
        $(tabid).show();
    } else {
        $("ul.tabsLeft li:first").addClass("active"); //Activate first tab
        $("div.attorneytab:first").show(); //Show first tab content
    }

    //services tabs
    $("div.servicestab").hide();
    $("ul.tabTop li").click(function (e) {

        $("div.servicestab").hide();
        var activeTab = $(this).find("a").attr("id").replace("#", "#tab");
        $(activeTab).fadeIn();

        $("li.tablink").removeClass("active");
        $(this).addClass("active");
    });

    if (location.hash != "" && $(location.hash.replace("#", "#tab")).length > 0) {
        var tabid = location.hash.replace("#", "#tab")
        $("a[href=\"\\" + location.hash + "\"]").parent("ul.tabTop li").addClass("active");
        $(tabid).show();
    } else {
        $("ul.tabTop li:first").addClass("active"); //Activate first tab
        $("div.servicestab:first").show(); //Show first tab content
    }
});

function ChangeDiv(objID, cName) {
    if (document.getElementById(objID)) {
        document.getElementById(objID).className = cName;
    }

}

//dynamic loaders
// initialize a dynamic data loader
$.fn.DynamicDataLoader = function (options) {
    var resultElement = this;
    var requestCache = [];

    var settings = $.extend({
        getUrl: '',         // url used to request data from the server
        onPreProcess: null, // preprocessing step before data is attached to template (return data object)
        onSuccess: null,    // step when everything is successful
        onEmpty: null,      // step when data is empty
        onFailure: null,    // step when a failure occurs while requesting data from server
        onComplete: null,   // final step
        successTemplateId: '',
        failureTemplateId: '',
        onEmptyResultText: 'No data found',
        onErrorResultText: 'An error occurred while requesting data',
        enableResultCache: true
    }, options);

    if (settings.successTemplateId.length == 0)
        throw "The dynamic data loader functionality requires a success template";

    if (settings.getUrl.indexOf('?') < 0) {
        settings.getUrl += '?';
    }

    initializeTemplate();

    if (settings.failureTemplateId.length > 0)
        $('#' + settings.failureTemplateId).template(settings.failureTemplateId);

    function initializeTemplate() {
        if (typeof ($('#' + settings.successTemplateId).template[settings.successTemplateId]) == "undefined") {
            $('#' + settings.successTemplateId).template(settings.successTemplateId);
        }
    }

    function success(requestData, data) {

        if (settings.enableResultCache) {
            var cacheString = toString(requestData);
            requestCache[cacheString] = data;
        }

        if (settings.onPreProcess) data = settings.onPreProcess(data);

        if (data == null || data.length == 0) {
            displayError(settings.onEmptyResultText, '');
            if (settings.onEmpty) settings.onEmpty();
        } else {
            displayData(data.Results);
            if (settings.onSuccess) settings.onSuccess();
        }
        if (settings.onComplete) settings.onComplete(data);
    }

    function error(xhr, statusText, errorText) {
        displayError(settings.onErrorResultText, errorText);
        if (settings.onFailure) settings.onFailure(errorText);
        if (settings.onComplete) settings.onComplete();
    }

    // display the success data 
    function displayData(data) {
        $.tmpl(settings.successTemplateId, data)
			.appendTo(resultElement);
    }

    // display an error using the failure template (if provided)
    function displayError(friendlyText, errorText) {
        if (settings.failureTemplateId.length == 0)
            return;
        $.tmpl(settings.failureTemplateId, { Message: friendlyText, Error: errorText })
			.appendTo(resultElement);
    }

    function toString(data) {
        var string = '';
        for (var parm in data) {
            string += (parm + '|' + data[parm]);
        }
        return string;
    }

    return {
        makeRequest: function (requestData) {
            if (settings.enableResultCache) {
                var cacheString = toString(requestData);
                if (requestCache[cacheString]) {
                    success(requestData, requestCache[cacheString]);
                    return;
                }
            }

            $.ajax({
                type: "GET",
                url: settings.getUrl + '&r=' + (new Date().toUTCString()),
                mimeType: "application/json",
                dataType: "json",
                success: function (data) { success(requestData, data); },
                error: error,
                headers: requestData,
                global: false
            });
        },
        changeTemplateId: function (templateId) {
            settings.successTemplateId = templateId;
            initializeTemplate();
        },
        changeUrl: function (url) {
            settings.getUrl = url;
        },
        init: function (initialData) {
            if (initialData) {
                settings.onPreProcess(initialData);
            }
        }
    };
};



$.fn.DynamicPager = function (options) {
    var resultElement = this;

    var settings = $.extend({
        showMoreElement: null,
        pagingTemplate: null,
        highIndexElement: null,
        getUrl: null,
        query: null,
        speed: 300,
        initialPageSize: 10,
        totalItems: 0
    }, options);

    var iTotalItems = parseInt(settings.totalItems);
    var iInitPageSize = parseInt(settings.initialPageSize);
    if (!settings.alwaysshow && iTotalItems <= iInitPageSize) {
        settings.showMoreElement.parent().animate({ "opacity": 0.0 }, settings.speed);
        settings.showMoreElement.parent().hide();
    }

    var pagingRequester = resultElement.DynamicDataLoader
        ({
            getUrl: settings.getUrl,
            onEmpty: null,
            onFailure: null,
            onComplete: function (result) {
                if (result.HighIndex == result.TotalItems) {
                    //showing last page. hide viewall,viewmore
                    settings.showMoreElement.parent().animate({ "opacity": 0.0 }, settings.speed);
                    settings.showMoreElement.parent().hide();
                } else {
                    settings.showMoreElement.parent().animate({ "opacity": 1.0 }, settings.speed);
                    settings.showMoreElement.parent().show();
                }

                if (result.TotalItems <= settings.initialPageSize) {
                    //hide the whole paging
                    settings.showMoreElement.parent().animate({ "opacity": 0.0 }, settings.speed);
                    settings.showMoreElement.parent().hide();
                }

                settings.highIndexElement.text(result.HighIndex);
            },
            emptyContainer: false,
            successTemplateId: settings.pagingTemplate
        });

    settings.showMoreElement.click(function () {
        // Run Search
        var requestData = {
            section: settings.section,
            itemid: settings.itemid,
            query: settings.query,
            ps: settings.initialPageSize,
            last: settings.highIndexElement.text()
        };

        pagingRequester.makeRequest(requestData);
    });
};
